<script setup>
import { computed } from "vue";

const props = defineProps({
  modelValue: { type: String, default: "" },
  type: { type: String, default: "text" },
  id: { type: String, default: undefined },
  name: { type: String, default: undefined },
  placeholder: { type: String, default: "" },
  disabled: { type: Boolean, default: false },
  // 'error' | 'success' | null
  status: { type: String, default: null },
  autocomplete: { type: String, default: undefined },
  maxlength: { type: [String, Number], default: undefined },
});

defineEmits(["update:modelValue", "blur", "focus", "keydown", "keyup"]);

const classes = computed(() => [
  "ca-input",
  props.status === "error" && "ca-input--error",
  props.status === "success" && "ca-input--success",
]);
</script>

<template>
  <input
    :class="classes"
    :type="type"
    :id="id"
    :name="name"
    :value="modelValue"
    :placeholder="placeholder"
    :disabled="disabled"
    :autocomplete="autocomplete"
    :maxlength="maxlength"
    @input="$emit('update:modelValue', $event.target.value)"
    @blur="$emit('blur', $event)"
    @focus="$emit('focus', $event)"
    @keydown="$emit('keydown', $event)"
    @keyup="$emit('keyup', $event)"
  />
</template>
